import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 1850,
    y: 1530,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan! Ya ampun tolong Yan!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Cepat cari bantuan!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3",
        },
        elsa_3: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Elsa, tenang, ada apa?',
              nextDialogId: 'elsa_4',
            },
            {
              text: 'Apa yang terjadi Elsa?',
              nextDialogId: 'elsa_4',
            },
          ],
        },
        elsa_4: {
          id: 'elsa_4',
          speaker: 'Elsa',
          text: `Sebaiknya kamu masuk kedalam.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'part1_b1',
        },
        part1_b1: {
          id: 'part1_4',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId: 'part1_b2',
          sfx: "running"
        },
        part1_b2: {
          id: 'part1_4',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_b4',
          sfx : "orchestraFreak"
        },
        part1_b4: {
          id: 'part1_4',
          speaker: 'Yan',
          text: `Apa yang harus aku lakukan`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          choices: [
            {
              text: 'Teriak meminta tolong',
              nextDialogId: 'part1_c1',
            },
            {
              text: 'Tenang dan investigasi',
              nextDialogId: 'part1_d1',
            },
          ],
        },
        part1_c1: {
          id: 'part1_4',
          speaker: 'Yan',
          text: `Tolong!!!!`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId: 'part1_c2',
        },
        part1_c2: {
          id: 'part1_4',
          speaker: 'Yan',
          text: `Tolong!!!!`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId: 'part1_c3',
        },
        part1_c3: {
          id: 'part1_4',
          speaker: 'Elsa',
          text: `Sepertinya tidak ada siapa-siapa.`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/elsa.png',
          nextDialogId: 'part1_c4',
        },
        part1_c4: {
          id: 'part1_4',
          speaker: '',
          text: `Mungkin saatnya tenang dan coba kita analisa situasi ini`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId: 'part1_d1',
        },
        part1_d1: {
          id: 'part1_4',
          speaker: '',
          text: `Bagian apa yang ingin di investigasi`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          choices: [
            {
              text: 'Tumpahan Darah',
              nextDialogId: 'part1_e1',
            },
            {
              text: 'Kondisi badan Diana',
              nextDialogId: 'part1_f1',
            },
            {
              text: 'Selesai investigasi',
              nextDialogId: 'part1_g1',
            },
          ],
        },
        part1_e1: {
          id: 'part1_e1',
          speaker: '',
          text: `Darah masih mengalir dan menetes ke lantai`,
          backgroundImage: '/assets/cutscene/death_diana_blood_zoom.png',
          nextDialogId: 'part1_e2',
        },
        part1_e2: {
          id: 'part1_e1',
          speaker: '',
          text: `Sepertinya darah masih baru, belum ada darah yang kering`,
          backgroundImage: '/assets/cutscene/death_diana_blood_zoom.jpg',
          nextDialogId: 'part1_d1',
        },
        part1_f1: {
          id: 'part1_f1',
          speaker: '',
          text: `Kondisi badan kering, serupa dengan kematian Sondakh`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_d1',
        },
        part1_g1: {
          id: 'part1_g1',
          speaker: 'Yan',
          text: `Sebaiknya kita keluar mencari bantuan`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          storyAction: { type: 'nextDay', value: 0 },
        },
      },
    },
  },
];

export default config;
